import { useState } from "react";
import styled from "@emotion/styled";
import { BaseCell } from "./BaseCell";
import { ChevronProgressSectionDown } from "src/assets/icons";
import StatusSelector from "src/components/dropdowns/StatusSelector";
import { GhostButton } from "src/components/Buttons";

const Container = styled(BaseCell)`
  flex: 1;
  position: relative;
`;

interface HeaderStatusCellProps {
  selectedStatuses: string[];
  setSelectedStatuses: (statuses: string[]) => void;
}

export const HeaderStatusCell = ({
  selectedStatuses,
  setSelectedStatuses,
}: HeaderStatusCellProps) => {
  const [showMenu, setShowMenu] = useState(false);
  let title = "Status";
  if (selectedStatuses.length > 0) {
    title += `: ${selectedStatuses.length} selected`;
  }
  return (
    <Container>
      <GhostButton onClick={() => setShowMenu(!showMenu)}>
        {title}
        <ChevronProgressSectionDown />
      </GhostButton>
      <StatusSelector
        showMenu={showMenu}
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={setSelectedStatuses}
      />
    </Container>
  );
};
